import { RefObject, useEffect } from 'react';

export function useClickOutside<T extends HTMLElement>(
  refs: Array<RefObject<T | undefined>>,
  callback: () => void
) {
  useEffect(() => {
    /**
     * Outside click event listener
     */
    const handleClickOutside: EventListener = (event) => {
      let inside = false;
      for (let i = 0; i < refs.length; i++) {
        const r = refs[i];
        if (r.current && r.current.contains(event.target as Node)) {
          inside = true;
          break;
        }
      }
      if (!inside) {
        if (callback) {
          callback();
        }
      }
    };
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [refs]);
}
